<template>
  <div class="component-container">
    <a @click.prevent="subtractAmount" class="btn">-</a>
    <input class="amount" type="number" :step="step" :placeholder="placeholder" v-model="input_amount" min="0">
    <a @click.prevent="addAmount" class="btn">+</a>
  </div>
</template>

<script>
export default {
  props: {
    'amount': {},
    'placeholder': {
      default: 'Aantal'
    },
    'step': {
      default: 1,
      type: Number
    },
    'decimals': {
    default: 0
    }
  },
  emits: ['update:amount'],
  data() {
    return {
    }
  },
  computed: {
    input_amount: {
      get() {
        return this.amount
      },
      set(value) {
        this.$emit('update:amount', value)
      }
    }
  },
  methods: {
    subtractAmount() {
      let value = this.input_amount;
      // if value is null or empty
      if(isNaN(parseInt(this.input_amount)))  {
        value = 0;
      }
      value = parseFloat(value) - parseFloat(this.step);
      // min value is 0
      if(value < 0) {
        value = 0;
      }
      this.input_amount = parseFloat(value.toFixed(this.decimals));
    },
    addAmount() {
      let value = this.input_amount;
      // if value is null or empty
      if(isNaN(parseInt(this.input_amount)))  {
        value = 0;
      }
      value = parseFloat(value) + parseFloat(this.step);
      this.input_amount = parseFloat(value.toFixed(this.decimals));
    }
  }

}
</script>

<style scoped>
.component-container {
  display: inline-flex;
  align-items: center;
  justify-content: end;
  margin-left: 10px;
}
.amount {
  display: inline-flex;
  align-items: center;
  width: 46px;
  padding: 0px 7px;
  height: 40px;
  font-size: 18px;
  border: 1px solid #bfbfbf;
  text-align: center;
  border-radius: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  background: #bfbfbf;
  padding: 0 12px 0 12px;
  height: 42px;
  font-size: 18px;
  border: 1px solid #bfbfbf;
}
/* remove default increase/decrease buttons */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>